import { useCustomSelector } from './useCustomSelector';
import { COMMUNICATION_WIDGETS_REDUCER } from '../constants';

import { TCommunicationWidgetsSelector, TEqualityFunction } from '../types';

export const useCommunicationWidgetsSelector = <TSelected>(
    selector: TCommunicationWidgetsSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof COMMUNICATION_WIDGETS_REDUCER>(
        COMMUNICATION_WIDGETS_REDUCER,
        selector,
        equalityFn
    );
};
